<template>
    <div v-if="fancyDetails" v-html="fancyDetails"></div>
</template>

<script>
import { isNullOrUndefined } from 'ceres/app/helper/utils';
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";

export default
{
    data() {
        return {
            lazyImages: [],
            mounted: false,
            lazyLoadImages: true
        }
    },

    computed: {
        fancyDetails() {

            if(typeof this.$store.getters.currentItemVariation.variationProperties !== 'undefined' && this.mounted) {

                const details = this.$store.getters.currentItemVariation.variationProperties[0].properties.find(prop => prop.id === 7);

                if(details) {
                    return this.setLazyImage(details.values.value);
                }
            }

            return false;
        },
        pluginPath()
        {
            return App.pluginPathCeres;
        }
    },

    watch: {
        fancyDetails() {
            this.$nextTick(() => {
                this.lazyImages = [].slice.call(document.querySelectorAll('.lazy-img-vue'));
            });
        }
    },

    mounted()
    {
        this.mounted = true;

        this.$nextTick(() => {
            this.loadLightbox();
            this.lazyLoad();
        });

        document.addEventListener('scroll', this.lazyLoad, detectPassiveEvents() ? { passive: true } : false);
        window.addEventListener('resize', this.lazyLoad);
        window.addEventListener('orientationchange', this.lazyLoad);

        //disable lazy load so scroll to of reviews is working correct (od-custom.js:94 and scrollList.vue:102)
        document.addEventListener('toggle-details-lazy-load', () => {
            this.lazyLoadImages = !this.lazyLoadImages;
        });
    },

    methods: {
        loadLightbox()
        {
            return new Promise((resolve, reject) => {

                const script = document.querySelector('script#lightboxscript');

                if (!isNullOrUndefined(script)) {
                    resolve();
                }else {
                    const script = document.createElement('script');

                    script.type = 'text/javascript';
                    script.id = 'lightboxscript';
                    script.src = `${ this.pluginPath }/js/dist/lightbox.min.js`;

                    script.addEventListener('load', () => resolve(), false);
                    script.addEventListener('error', event => reject(event), false);

                    document.body.appendChild(script);
                }
            });
        },
        setLazyImage(html)
        {
            let dom = document.createElement('div');
            dom.innerHTML = html;
            const images = dom.getElementsByTagName('img');

            if(images) {
                for(let i = 0; i < images.length; i++) {
                    if(!images[i].classList.contains('lazy-img-vue')) {

                        images[i].classList.add('lazy-img-vue');

                        images[i].dataset.src = images[i].src;
                        images[i].removeAttribute('src');
                    }
                }
            }

            return dom.innerHTML;
        },
        lazyLoad()
        {
            if(this.lazyLoadImages && this.lazyImages.length > 0) {
                this.lazyImages.forEach(lazyImage => {

                    const bounding = lazyImage.getBoundingClientRect();

                    if(bounding.top <= window.innerHeight && bounding.bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {

                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove('lazy-img-vue');

                        this.lazyImages = this.lazyImages.filter((image) => {
                            return image !== lazyImage;
                        });

                        // if(this.lazyImages.length === 0) {
                        //     document.removeEventListener('scroll', this.lazyLoad);
                        //     window.removeEventListener('resize', this.lazyLoad);
                        //     window.removeEventListener('orientationchange', this.lazyLoad);
                        // }
                    }
                });
            }
        }
    }
}
</script>
